// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_container__HvkDB {
  margin-top: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(1.6);
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/Loader/index.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".container {\n  margin-top: 15%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: scale(1.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Loader_container__HvkDB`
};
export default ___CSS_LOADER_EXPORT___;
